import { render } from "./HomeMain.vue?vue&type=template&id=2146d6cb&ts=true"
import script from "./HomeMain.vue?vue&type=script&lang=ts"
export * from "./HomeMain.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__